<!--  /**
     * 轨迹完整分析的百度地图
     * @jlliang
     */-->
<template>
    <div>
        <baidu-map class="bm-view" :center="center" :zoom="zoom"
                   @ready="handler" :pinch-to-zoom="true">
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"></bm-geolocation>
            <bm-polyline :path="polylinePath1" :stroke-color="color1" :stroke-opacity="0.5"
                         :stroke-weight="2"></bm-polyline>
            <div v-for="item in list1">
                <bm-polyline :path="item" :stroke-color="color2" :stroke-opacity="1"
                             :stroke-weight="3"></bm-polyline>
            </div>
            <bm-polyline :path="polylinePath2" :stroke-color="color2" :stroke-opacity="1"
                         :stroke-weight="3"></bm-polyline>
            <bm-polyline :path="polylinePath3" :stroke-color="color3" :stroke-opacity="1"
                         :stroke-weight="3"></bm-polyline>
        </baidu-map>
    </div>
</template>

<script>
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import store from '@/store'

    export default {
        name: "BDmap",
        data() {
            return {
                list1:[],
                ControlAnchor: '',
                center: {lng: 0, lat: 0},
                zoom: 3,

                polylinePath1: [
                    {lng: 116.604, lat: 39.915},
                    {lng: 116.705, lat: 39.920},
                    {lng: 116.723493, lat: 39.907445}
                ],
                color1: 'blue',
                polylinePath2: [
                    {lng: 116.504, lat: 39.815},
                    {lng: 116.505, lat: 39.720},
                    {lng: 116.523493, lat: 39.607445}
                ],
                color2: 'red',
                polylinePath3: [
                    {lng: 116.604, lat: 39.815},
                    {lng: 116.605, lat: 39.720},
                    {lng: 116.623493, lat: 39.607445}
                ],
                color3: 'Orchid',
            }
        },
        components: {
            BaiduMap
        },
        methods: {
            handler({BMap, map}) {
                console.log(BMap, map)
                // this.center.lng = 116.404
                // this.center.lat = 39.915
                this.center = '北京'
                this.zoom = 10
            }
        },
        mounted() {
            console.log(this.$route.params.item)
            //全日折线
            store.dispatch('LocateHistoryServ_LoadDailyTrack', {
                params: {
                    terminalNum: this.$route.params.item.terminalNum,
                    selectDatetime: new Date(this.$route.params.item.analyzeDatetime).Format(('yyyy-MM-dd hh:mm:ss')),
                },
                urlparams: null
            }).then((res) => {
                console.log(res)
                this.polylinePath1 = []
                for (let i = 0; i < res.data.length; i++) {
                    this.polylinePath1.push({
                        lng: res.data[i].longitude,
                        lat: res.data[i].latitude
                    })
                    // console.log(this.polylinePath1)
                }


                //不连续轨迹折线
                if (this.$route.params.item.discontinuousTracksList) {
                    this.polylinePath2 = []
                    console.log(this.$route.params.item.discontinuousTracksList)
                    console.log(JSON.parse(this.$route.params.item.discontinuousTracksList))
                    console.log(JSON.parse(this.$route.params.item.discontinuousTracksList).discontinuousTracksList)
                    let polyline2 = JSON.parse(this.$route.params.item.discontinuousTracksList).discontinuousTracksList
                    for (let i = 0; i < polyline2.length; i++) {
                        for (let j = 0; j < polyline2[i].discontinuousTracks.length; j++) {
                            this.polylinePath2.push({
                                lng: polyline2[i].discontinuousTracks[j].lng,
                                lat: polyline2[i].discontinuousTracks[j].lat
                            })
                            // console.log(this.polylinePath2)
                        }
                    }
                    this.list1.push(this.polylinePath2)
                }

                //漂移轨迹折线
                if (this.$route.params.item.shiftTracksList) {
                    console.log(this.$route.params.item.shiftTracksList)
                    console.log(JSON.parse(this.$route.params.item.shiftTracksList))
                    console.log(JSON.parse(this.$route.params.item.shiftTracksList).shiftTracksList)
                    let polyline3 = JSON.parse(this.$route.params.item.shiftTracksList).shiftTracksList
                    for (let i = 0; i < polyline3.length; i++) {
                        for (let j = 0; j < polyline3[i].shiftTracks.length; j++) {
                            this.polylinePath2.push({
                                lng: polyline3[i].shiftTracks[j].lng,
                                lat: polyline3[i].shiftTracks[j].lat
                            })
                            // console.log(this.polylinePath3)
                        }
                    }
                }
            }).catch((err) => {
                console.log(err)
            })

        },
    }
</script>

<style scoped>
    .bm-view {
        width: 100%;
        height: 500px;
    }
</style>
